// extracted by mini-css-extract-plugin
export var arrow = "page-scroll-indicator-module--arrow--771ee";
export var arrowBounce = "page-scroll-indicator-module--arrowBounce--7e3a3";